<!-- Main Page and Parent component for all pages 
 Copy right - © 2024 tecera gmbh
 -->
<script>
    import { Router, Route } from "svelte-routing";
    import Hydranten from "./pages/Hydranten.svelte";
    import Login from "./pages/Login.svelte";
    import Register from "./pages/Register.svelte";
    import Reset from "./pages/Reset.svelte";
    import WasserZaehler from "./pages/WasserZaehler.svelte";
    import Vehicles from "./pages/Vehicles.svelte";
    import MontageUebersicht from "./pages/MontageUebersicht.svelte";
    import Verwaltung from "./pages/Verwaltung.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import DevPage from "./pages/DevPage.svelte";
    import Toast from "./components/Toast.svelte";
    import {DEBUG} from "./config.js";
    import TrinkwasserNetzdaten from "./pages/TrinkwasserNetzdaten.svelte";
    import DeviceVerwaltung from "./pages/DeviceVerwaltung.svelte";
    import BaseLayout from "./components/layouts/BaseLayout.svelte";
</script>

<Toast />

<Router>
    <Route path="/" component={Login} />
    <Route path="/register" component={Register} />
    <Route path="/reset_password" component={Reset} />
    <Route path="/pegel" component={Hydranten} />
    <Route path="/fahrzeuge" component={Vehicles} />
    <Route path="/user_management" component={Verwaltung} />
    <!-- <Route path="/montage_uebersicht" component={MontageUebersicht} /> -->
    <!-- <Route path="/wasserzaehler" component={WasserZaehler} /> -->
    <!-- <Route path="/trinkwasser" component={TrinkwasserNetzdaten} /> -->
    <!-- <Route path="/device_management" component={DeviceVerwaltung} /> -->

    {#if DEBUG}
    <Route path="/dev" component={DevPage} />
    <Route path="/dev2" component={BaseLayout} />
    {/if}
    <Route path="/*" component={NotFound} />
</Router>
